<template>
  <div class="min-h-screen bg-white dark:bg-[#0c1427] p-3" :dir="isRtl ? 'rtl' : 'ltr'">
    <div class="max-w-6xl mx-auto">
      <!-- Page Header -->
      <div class="mb-4">
        <div
          class="relative rounded-2xl p-3 shadow-lg hover:shadow-xl transition-shadow duration-300 overflow-hidden w-full"
          style="
            background: linear-gradient(135deg, #5856d6 0%, #af52de 100%);
            box-shadow: 0 8px 32px rgba(88, 86, 214, 0.3),
              inset 0 1px 0 rgba(255, 255, 255, 0.2);
          "
        >
          <!-- Background decorative elements -->
          <div class="absolute inset-0 overflow-hidden">
            <div
              class="absolute -top-20 -right-20 w-40 h-40 rounded-full opacity-20"
              style="
                background: radial-gradient(
                  circle,
                  rgba(255, 255, 255, 0.3) 0%,
                  transparent 70%
                );
              "
            ></div>
            <div
              class="absolute -bottom-16 -left-16 w-32 h-32 rounded-full opacity-15"
              style="
                background: radial-gradient(
                  circle,
                  rgba(255, 255, 255, 0.4) 0%,
                  transparent 70%
                );
              "
            ></div>
          </div>
          
          <!-- Header content -->
          <div class="relative z-10">
            <div class="flex items-center justify-between">
          <div class="flex items-center gap-4">
                <div class="relative flex-shrink-0">
                  <div class="w-20 h-20 rounded-full bg-white/20 backdrop-blur-sm border-3 border-white/70 shadow-xl flex items-center justify-center">
                    <i class="material-symbols-outlined text-white text-3xl">handshake</i>
              </div>
                </div>
                
              <div>
                  <h1 class="text-2xl font-bold text-white drop-shadow-sm mb-1">
                    {{ directT('crm.deals.form.title') }}
                  </h1>
                  <p class="text-white/80 text-sm font-medium">
                    {{ directT('crm.deals.form.subtitle') }}
                  </p>
                </div>
              </div>
              </div>
            </div>
          </div>
        </div>
        
      <!-- Main Content -->
      <form @submit.prevent="saveDeal">
        <div class="lg:grid lg:grid-cols-3 gap-6">
          <div class="lg:col-span-2 space-y-6">
          <!-- Error Message -->
            <div v-if="error" class="p-4 bg-red-50/80 dark:bg-red-900/20 backdrop-blur-xl rounded-2xl shadow-lg border border-red-200/50 dark:border-red-800/30 mb-6">
              <div class="flex items-start gap-4">
                <div class="w-10 h-10 bg-red-500/10 rounded-xl flex items-center justify-center">
                  <i class="material-symbols-outlined text-red-500 text-xl">error</i>
                </div>
                <div>
                  <h3 class="text-lg font-semibold text-red-700 dark:text-red-400">שגיאה</h3>
                  <p class="text-red-600 dark:text-red-300 mt-1">{{ error }}</p>
                </div>
            </div>
          </div>
          
            <!-- Client Search Section -->
            <div class="bg-white dark:bg-[#1a1a1a] rounded-2xl shadow-lg border border-gray-200/50 dark:border-gray-700/50 p-6 mb-6">
              <div class="flex items-center gap-3 mb-6">
                <div class="w-10 h-10 bg-gradient-to-br from-[#5856d6] to-[#af52de] rounded-xl flex items-center justify-center">
                  <i class="material-symbols-outlined text-white text-lg">person</i>
                </div>
                <h3 class="text-lg font-bold text-gray-900 dark:text-white leading-none h-10 flex items-center">
                {{ directT('crm.deals.form.selectClient') || 'בחר לקוח' }}
                </h3>
              </div>

              <!-- Client Search -->
              <div class="group">
                <label class="block text-xs font-semibold text-gray-800 dark:text-gray-200 mb-2 flex items-center gap-2">
                  <i class="material-symbols-outlined text-purple-600 text-sm">search</i>
                  {{ directT('crm.deals.form.searchClient') || 'חפש לקוח קיים' }}
                </label>
                <div class="relative">
                  <input
                    v-model="clientSearchTerm"
                    type="text"
                    @input="searchClients"
                    @focus="showClientDropdown = true"
                    @blur="handleSearchBlur"
                    class="w-full px-4 py-3 bg-white dark:bg-gray-800 border-2 border-gray-200 dark:border-gray-600 rounded-xl focus:ring-2 focus:ring-purple-500/20 focus:border-purple-500 text-sm bg-white/80 backdrop-blur-sm transition-all duration-200 shadow-sm hover:shadow-md text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400"
                    :placeholder="directT('crm.deals.form.searchClientPlaceholder') || 'חפש לפי שם או טלפון...'"
                  />
                  <div class="absolute right-3 top-1/2 -translate-y-1/2">
                    <i class="material-symbols-outlined text-gray-400 text-sm">search</i>
                  </div>
                  
                  <!-- Dropdown Results -->
                  <div v-if="showClientDropdown && (searchingClients || filteredClients.length > 0)" 
                       class="absolute top-full left-0 right-0 mt-2 bg-white dark:bg-[#1a1a1a] rounded-2xl shadow-2xl border border-[#E5E7EB] dark:border-[#374151] max-h-60 overflow-y-auto z-50">
                    
                    <!-- Loading State -->
                    <div v-if="searchingClients" class="p-4 text-center">
                      <div class="inline-block w-5 h-5 border-2 border-[#34C759] border-t-transparent rounded-full animate-spin"></div>
                      <p class="text-[#666666] dark:text-[#cccccc] mt-2">{{ directT('crm.deals.form.searching') || 'מחפש...' }}</p>
                    </div>
                    
                    <!-- Client Results -->
                    <div v-else-if="filteredClients.length > 0">
                      <button
                        v-for="client in filteredClients"
                        :key="client.id"
                        type="button"
                        @click="selectClient(client)"
                        class="w-full px-4 py-3 hover:bg-[#F0F9F5] dark:hover:bg-[#0a1a0f] transition-colors text-left border-b border-[#E5E7EB] dark:border-[#374151] last:border-0"
                      >
                        <div class="flex items-center justify-between">
                          <div>
                            <p class="font-semibold text-[#1a1a1a] dark:text-white">
                              {{ getClientFullName(client) }}
                            </p>
                            <p class="text-sm text-[#666666] dark:text-[#cccccc]">
                              {{ client.phone || 'אין טלפון' }}
                            </p>
                          </div>
                          <i class="ri-arrow-left-s-line text-[#34C759]"></i>
                        </div>
                      </button>
                    </div>
                    
                    <!-- No Results -->
                    <div v-else class="p-4 text-center text-[#666666] dark:text-[#cccccc]">
                      {{ directT('crm.deals.form.noClientsFound') || 'לא נמצאו לקוחות' }}
                    </div>
                  </div>
                </div>
                
                <!-- Selected Client Display -->
                <div v-if="selectedClient" class="mt-3 p-3 bg-[#F0F9F5] dark:bg-[#0a1a0f] rounded-xl flex items-center justify-between">
                  <div class="flex items-center gap-3">
                    <div class="w-10 h-10 bg-[#34C759] rounded-xl flex items-center justify-center">
                      <i class="ri-user-3-fill text-white"></i>
                    </div>
                    <div>
                      <p class="font-semibold text-[#1a1a1a] dark:text-white">{{ getClientFullName(selectedClient) }}</p>
                      <p class="text-sm text-[#666666] dark:text-[#cccccc]">{{ selectedClient.phone || 'אין טלפון' }}</p>
                    </div>
                  </div>
                  <button
                    type="button"
                    @click="clearSelectedClient"
                    class="p-2 hover:bg-[#34C759]/10 rounded-lg transition-colors"
                  >
                    <i class="ri-close-line text-[#666666] dark:text-[#cccccc]"></i>
                  </button>
                </div>
                
                <!-- Create New Client Option -->
                <div v-if="!selectedClient" class="mt-3 text-center">
                  <p class="text-sm text-[#666666] dark:text-[#cccccc] mb-2">
                    {{ directT('crm.deals.form.clientNotFound') || 'לא מצאת את הלקוח?' }}
                  </p>
                  <router-link 
                    to="/crm/customers"
                    class="inline-flex items-center gap-2 text-[#5856d6] hover:text-[#af52de] font-medium text-sm transition-colors underline"
                  >
                    <i class="ri-user-add-line"></i>
                    {{ directT('crm.deals.form.createNewClient') || 'צור לקוח חדש' }}
                  </router-link>
                </div>
              </div>
            </div>
            
            <!-- Deal Information Section -->
            <div class="bg-white dark:bg-[#1a1a1a] rounded-2xl shadow-lg border border-gray-200/50 dark:border-gray-700/50 p-6 mb-6">
              <div class="flex items-center gap-3 mb-6">
                <div class="w-10 h-10 bg-gradient-to-br from-[#5856d6] to-[#af52de] rounded-xl flex items-center justify-center">
                  <i class="material-symbols-outlined text-white text-lg">description</i>
                </div>
                <h3 class="text-lg font-bold text-gray-900 dark:text-white leading-none h-10 flex items-center">
                {{ directT('crm.deals.form.dealInformation') }}
                </h3>
              </div>
              
              <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                <!-- Deal Title -->
                <div class="md:col-span-2 group">
                  <label class="block text-xs font-semibold text-gray-800 dark:text-gray-200 mb-2 flex items-center gap-2">
                    <i class="material-symbols-outlined text-purple-600 text-sm">title</i>
                    {{ directT('crm.deals.form.dealTitle') }}
                    <span class="text-red-500">*</span>
                  </label>
                  <div class="relative">
                  <input
                    v-model="newDeal.title"
                    type="text"
                    required
                    :placeholder="directT('crm.deals.form.dealTitlePlaceholder')"
                      class="w-full px-4 py-3 bg-white dark:bg-gray-800 border-2 border-gray-200 dark:border-gray-600 rounded-xl focus:ring-2 focus:ring-purple-500/20 focus:border-purple-500 text-sm bg-white/80 backdrop-blur-sm transition-all duration-200 shadow-sm hover:shadow-md text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400"
                  />
                    <div class="absolute right-3 top-1/2 -translate-y-1/2">
                      <i class="material-symbols-outlined text-gray-400 text-sm">edit</i>
                    </div>
                  </div>
                </div>
                
                <!-- Deal Amount -->
                <div class="group">
                  <label class="block text-xs font-semibold text-gray-800 dark:text-gray-200 mb-2 flex items-center gap-2">
                    <i class="material-symbols-outlined text-purple-600 text-sm">payments</i>
                    {{ directT('crm.deals.form.amount') }}
                  </label>
                  <div class="relative">
                    <input
                      v-model="newDeal.amount"
                      type="number"
                      step="0.01"
                      :placeholder="directT('crm.deals.form.amountPlaceholder')"
                      class="w-full px-4 py-3 bg-white dark:bg-gray-800 border-2 border-gray-200 dark:border-gray-600 rounded-xl focus:ring-2 focus:ring-purple-500/20 focus:border-purple-500 text-sm bg-white/80 backdrop-blur-sm transition-all duration-200 shadow-sm hover:shadow-md text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400"
                    />
                    <div class="absolute right-3 top-1/2 -translate-y-1/2">
                      <i class="material-symbols-outlined text-gray-400 text-sm">attach_money</i>
                    </div>
                  </div>
                </div>
                
                <!-- Deal Status -->
                <div class="group">
                  <label class="block text-xs font-semibold text-gray-800 dark:text-gray-200 mb-2 flex items-center gap-2">
                    <i class="material-symbols-outlined text-purple-600 text-sm">flag</i>
                    {{ directT('crm.deals.form.status') }}
                    <span class="text-red-500">*</span>
                  </label>
                  <div class="relative">
                  <select
                    v-model="newDeal.status"
                    required
                      class="w-full px-4 py-3 bg-white dark:bg-gray-800 border-2 border-gray-200 dark:border-gray-600 rounded-xl focus:ring-2 focus:ring-purple-500/20 focus:border-purple-500 text-sm bg-white/80 backdrop-blur-sm transition-all duration-200 shadow-sm hover:shadow-md text-gray-900 dark:text-white cursor-pointer appearance-none"
                  >
                    <option value="new">{{ directT('crm.deals.form.statusOptions.new') }}</option>
                    <option value="in progress">{{ directT('crm.deals.form.statusOptions.inProgress') }}</option>
                    <option value="on hold">{{ directT('crm.deals.form.statusOptions.onHold') }}</option>
                    <option value="pending">{{ directT('crm.deals.form.statusOptions.pending') }}</option>
                    <option value="negotiation">{{ directT('crm.deals.form.statusOptions.negotiation') }}</option>
                    <option value="closed">{{ directT('crm.deals.form.statusOptions.closed') }}</option>
                  </select>
                    <div class="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none">
                      <i class="material-symbols-outlined text-gray-400 text-sm">expand_more</i>
                    </div>
                  </div>
                </div>
                
                <!-- Closed By -->
                <div class="group">
                  <label class="block text-xs font-semibold text-gray-800 dark:text-gray-200 mb-2 flex items-center gap-2">
                    <i class="material-symbols-outlined text-purple-600 text-sm">person_check</i>
                    {{ directT('crm.deals.form.closedBy') || 'נסגר על ידי' }}
                  </label>
                  <div class="relative">
                    <select
                      v-model="newDeal.closed_by"
                      class="w-full px-4 py-3 bg-white dark:bg-gray-800 border-2 border-gray-200 dark:border-gray-600 rounded-xl focus:ring-2 focus:ring-purple-500/20 focus:border-purple-500 text-sm bg-white/80 backdrop-blur-sm transition-all duration-200 shadow-sm hover:shadow-md text-gray-900 dark:text-white cursor-pointer appearance-none"
                    >
                      <option value="">{{ directT('crm.deals.form.selectUser') || 'בחר משתמש' }}</option>
                      <option v-for="user in users" :key="user.user_id" :value="user.user_id">
                        {{ user.display_name || user.email }}
                      </option>
                    </select>
                    <div class="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none">
                      <i class="material-symbols-outlined text-gray-400 text-sm">expand_more</i>
                    </div>
                  </div>
                </div>
                
                <!-- Description -->
                <div class="md:col-span-2 group">
                  <label class="block text-xs font-semibold text-gray-800 dark:text-gray-200 mb-2 flex items-center gap-2">
                    <i class="material-symbols-outlined text-purple-600 text-sm">description</i>
                    {{ directT('crm.deals.form.description') }}
                  </label>
                  <div class="relative">
                  <textarea
                    v-model="newDeal.description"
                    rows="4"
                      class="w-full px-4 py-3 bg-white dark:bg-gray-800 border-2 border-gray-200 dark:border-gray-600 rounded-xl focus:ring-2 focus:ring-purple-500/20 focus:border-purple-500 text-sm bg-white/80 backdrop-blur-sm transition-all duration-200 shadow-sm hover:shadow-md text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400 resize-none"
                    :placeholder="directT('crm.deals.form.descriptionPlaceholder')"
                  ></textarea>
                    <div class="absolute right-3 top-3">
                      <i class="material-symbols-outlined text-gray-400 text-sm">edit</i>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Custom Fields Section - Regular Fields -->
            <div v-if="customFields.length > 0" class="bg-white dark:bg-[#1a1a1a] rounded-2xl shadow-lg border border-gray-200/50 dark:border-gray-700/50 p-6 mb-6">
              <div class="flex items-center gap-3 mb-6">
                <div class="w-10 h-10 bg-gradient-to-br from-[#5856d6] to-[#af52de] rounded-xl flex items-center justify-center">
                  <i class="material-symbols-outlined text-white text-lg">tune</i>
                </div>
                <h3 class="text-lg font-bold text-gray-900 dark:text-white leading-none h-10 flex items-center">
                  {{ directT('crm.deals.form.customFields') || 'שדות מותאמים אישית' }}
                </h3>
              </div>
              
              <div v-if="loadingCustomFields" class="flex justify-center items-center py-8">
                <div class="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-purple-500"></div>
              </div>
              
              <div v-else class="grid grid-cols-1 md:grid-cols-2 gap-6">
                <template v-for="field in customFields" :key="field.key">
                  <div :class="{'md:col-span-2': field.type === 'textarea'}" class="group">
                    <label class="block text-xs font-semibold text-gray-800 dark:text-gray-200 mb-2 flex items-center gap-2">
                      <i class="material-symbols-outlined text-purple-600 text-sm">
                        {{ field.type === 'text' ? 'text_fields' : 
                            field.type === 'number' ? 'numbers' :
                            field.type === 'email' ? 'email' :
                            field.type === 'phone' ? 'phone' :
                            field.type === 'date' ? 'calendar_today' :
                            field.type === 'select' ? 'arrow_drop_down' :
                            field.type === 'textarea' ? 'notes' :
                            'text_fields' }}
                      </i>
                      {{ field.label }}{{ field.required ? ' *' : '' }}
                    </label>
                    <div class="relative">
                      <!-- Text, number, email, phone, date inputs -->
                      <input 
                        v-if="getInputType(field.type) !== 'select' && field.type !== 'textarea' && field.type !== 'checkbox'"
                        :type="getInputType(field.type)"
                        v-model="customFieldValues[field.key]"
                        :required="field.required"
                        :placeholder="field.placeholder || ''"
                        class="w-full px-4 py-3 bg-white dark:bg-gray-800 border-2 border-gray-200 dark:border-gray-600 rounded-xl focus:ring-2 focus:ring-purple-500/20 focus:border-purple-500 text-sm bg-white/80 backdrop-blur-sm transition-all duration-200 shadow-sm hover:shadow-md text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400"
                      />
                      
                      <!-- Textarea for text area fields -->
                      <textarea 
                        v-else-if="field.type === 'textarea'"
                        v-model="customFieldValues[field.key]"
                        :required="field.required"
                        :placeholder="field.placeholder || ''"
                        rows="3"
                        class="w-full px-4 py-3 bg-white dark:bg-gray-800 border-2 border-gray-200 dark:border-gray-600 rounded-xl focus:ring-2 focus:ring-purple-500/20 focus:border-purple-500 text-sm bg-white/80 backdrop-blur-sm transition-all duration-200 shadow-sm hover:shadow-md text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400 resize-none"
                      ></textarea>
                      
                      <!-- Checkbox for boolean fields -->
                      <div v-else-if="field.type === 'checkbox'" class="flex items-center pt-2">
                        <input
                          type="checkbox"
                          v-model="customFieldValues[field.key]"
                          :id="`custom-field-${field.key}`"
                          class="w-5 h-5 text-purple-600 bg-white dark:bg-gray-800 border-2 border-gray-200 dark:border-gray-600 rounded focus:ring-purple-500/20 focus:ring-2"
                        />
                        <label :for="`custom-field-${field.key}`" class="ml-3 text-sm text-gray-900 dark:text-white">
                          {{ field.placeholder || field.label }}
                        </label>
                      </div>
                      
                      <!-- Dropdown for select fields -->
                      <select
                        v-else
                        v-model="customFieldValues[field.key]"
                        :required="field.required"
                        class="w-full px-4 py-3 bg-white dark:bg-gray-800 border-2 border-gray-200 dark:border-gray-600 rounded-xl focus:ring-2 focus:ring-purple-500/20 focus:border-purple-500 text-sm bg-white/80 backdrop-blur-sm transition-all duration-200 shadow-sm hover:shadow-md text-gray-900 dark:text-white cursor-pointer appearance-none"
                      >
                        <option value="">{{ directT('crm.deals.form.selectOption') || 'בחר אפשרות' }}</option>
                        <option v-for="option in field.options" :key="option" :value="option">{{ option }}</option>
                      </select>
                      
                      <!-- Icon for input fields -->
                      <div v-if="field.type !== 'checkbox' && field.type !== 'textarea'" class="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none">
                        <i class="material-symbols-outlined text-gray-400 text-sm">
                          {{ field.type === 'select' ? 'expand_more' : 'edit' }}
                        </i>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </div>

            <!-- System Areas (Cards) -->
            <template v-for="area in systemAreas" :key="area.id">
              <div class="bg-white dark:bg-[#1a1a1a] rounded-2xl shadow-lg border border-gray-200/50 dark:border-gray-700/50 p-6 mb-6">
                <div class="flex items-center gap-3 mb-6">
                  <div class="w-10 h-10 bg-gradient-to-br from-[#5856d6] to-[#af52de] rounded-xl flex items-center justify-center">
                    <i class="material-symbols-outlined text-white text-lg">dashboard</i>
                  </div>
                  <h3 class="text-lg font-bold text-gray-900 dark:text-white leading-none h-10 flex items-center">
                    {{ area.title }}
                  </h3>
                </div>
                
                <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <template v-for="field in area.fields" :key="field.key">
                    <div :class="{'md:col-span-2': field.type === 'textarea'}" class="group">
                      <label class="block text-xs font-semibold text-gray-800 dark:text-gray-200 mb-2 flex items-center gap-2">
                        <i class="material-symbols-outlined text-purple-600 text-sm">
                          {{ field.type === 'text' ? 'text_fields' : 
                              field.type === 'number' ? 'numbers' :
                              field.type === 'email' ? 'email' :
                              field.type === 'phone' ? 'phone' :
                              field.type === 'date' ? 'calendar_today' :
                              field.type === 'select' ? 'arrow_drop_down' :
                              field.type === 'textarea' ? 'notes' :
                              'text_fields' }}
                        </i>
                        {{ field.label }}{{ field.required ? ' *' : '' }}
                      </label>
                      <div class="relative">
                        <!-- Text, number, email, phone, date inputs -->
                        <input 
                          v-if="getInputType(field.type) !== 'select' && field.type !== 'textarea' && field.type !== 'checkbox'"
                          :type="getInputType(field.type)"
                          v-model="customFieldValues[field.key]"
                          :required="field.required"
                          :placeholder="field.placeholder || ''"
                          class="w-full px-4 py-3 bg-white dark:bg-gray-800 border-2 border-gray-200 dark:border-gray-600 rounded-xl focus:ring-2 focus:ring-purple-500/20 focus:border-purple-500 text-sm bg-white/80 backdrop-blur-sm transition-all duration-200 shadow-sm hover:shadow-md text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400"
                        />
                        
                        <!-- Textarea for text area fields -->
                        <textarea 
                          v-else-if="field.type === 'textarea'"
                          v-model="customFieldValues[field.key]"
                          :required="field.required"
                          :placeholder="field.placeholder || ''"
                          rows="3"
                          class="w-full px-4 py-3 bg-white dark:bg-gray-800 border-2 border-gray-200 dark:border-gray-600 rounded-xl focus:ring-2 focus:ring-purple-500/20 focus:border-purple-500 text-sm bg-white/80 backdrop-blur-sm transition-all duration-200 shadow-sm hover:shadow-md text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400 resize-none"
                        ></textarea>
                        
                        <!-- Checkbox for boolean fields -->
                        <div v-else-if="field.type === 'checkbox'" class="flex items-center pt-2">
                          <input
                            type="checkbox"
                            v-model="customFieldValues[field.key]"
                            :id="`area-field-${field.key}`"
                            class="w-5 h-5 text-purple-600 bg-white dark:bg-gray-800 border-2 border-gray-200 dark:border-gray-600 rounded focus:ring-purple-500/20 focus:ring-2"
                          />
                          <label :for="`area-field-${field.key}`" class="ml-3 text-sm text-gray-900 dark:text-white">
                            {{ field.placeholder || field.label }}
                          </label>
                        </div>
                        
                        <!-- Dropdown for select fields -->
                        <select
                          v-else
                          v-model="customFieldValues[field.key]"
                          :required="field.required"
                          class="w-full px-4 py-3 bg-white dark:bg-gray-800 border-2 border-gray-200 dark:border-gray-600 rounded-xl focus:ring-2 focus:ring-purple-500/20 focus:border-purple-500 text-sm bg-white/80 backdrop-blur-sm transition-all duration-200 shadow-sm hover:shadow-md text-gray-900 dark:text-white cursor-pointer appearance-none"
                        >
                          <option value="">{{ directT('crm.deals.form.selectOption') || 'בחר אפשרות' }}</option>
                          <option v-for="option in field.options" :key="option" :value="option">{{ option }}</option>
                        </select>
                        
                        <!-- Icon for input fields -->
                        <div v-if="field.type !== 'checkbox' && field.type !== 'textarea'" class="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none">
                          <i class="material-symbols-outlined text-gray-400 text-sm">
                            {{ field.type === 'select' ? 'expand_more' : 'edit' }}
                          </i>
                        </div>
                      </div>
                    </div>
                  </template>
                </div>
              </div>
            </template>
            
                        <!-- Contact Information Section -->
            <div class="bg-white dark:bg-[#1a1a1a] rounded-2xl shadow-lg border border-gray-200/50 dark:border-gray-700/50 p-6 mb-6">
              <div class="flex items-center gap-3 mb-6">
                <div class="w-10 h-10 bg-gradient-to-br from-[#5856d6] to-[#af52de] rounded-xl flex items-center justify-center">
                  <i class="material-symbols-outlined text-white text-lg">contacts</i>
                </div>
                <h3 class="text-lg font-bold text-gray-900 dark:text-white leading-none h-10 flex items-center">
                {{ directT('crm.deals.form.contactInformation') }}
                </h3>
              </div>
              
              <!-- Info Message when client is selected -->
              <div v-if="selectedClient" class="mb-6 p-4 bg-[#F0F9F5] dark:bg-[#0a1a0f] rounded-2xl border border-[#34C759]/20">
                <div class="flex items-center gap-2">
                  <i class="ri-information-line text-[#34C759]"></i>
                  <p class="text-sm text-[#666666] dark:text-[#cccccc]">
                    {{ directT('crm.deals.form.autoFilledInfo') || 'השדות למטה מולאו אוטומטית מפרטי הלקוח שנבחר' }}
                  </p>
                </div>
              </div>
              
              <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                <!-- Contact Person -->
                <div class="group">
                  <label class="block text-xs font-semibold text-gray-800 dark:text-gray-200 mb-2 flex items-center gap-2">
                    <i class="material-symbols-outlined text-purple-600 text-sm">person</i>
                    {{ directT('crm.deals.form.contactPerson') }}
                    <span class="text-red-500">*</span>
                  </label>
                  <div class="relative">
                  <input
                    v-model="newDeal.name"
                    type="text"
                    required
                    :readonly="!!selectedClient"
                    :placeholder="directT('crm.deals.form.contactPersonPlaceholder')"
                      class="w-full px-4 py-3 bg-white dark:bg-gray-800 border-2 border-gray-200 dark:border-gray-600 rounded-xl focus:ring-2 focus:ring-purple-500/20 focus:border-purple-500 text-sm bg-white/80 backdrop-blur-sm transition-all duration-200 shadow-sm hover:shadow-md text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400"
                      :class="selectedClient ? 'bg-gray-100 dark:bg-gray-800 cursor-not-allowed' : ''"
                  />
                    <div class="absolute right-3 top-1/2 -translate-y-1/2">
                      <i class="material-symbols-outlined text-gray-400 text-sm">edit</i>
                    </div>
                  </div>
                </div>
                
                <!-- Phone Number -->
                <div class="group">
                  <label class="block text-xs font-semibold text-gray-800 dark:text-gray-200 mb-2 flex items-center gap-2">
                    <i class="material-symbols-outlined text-purple-600 text-sm">phone</i>
                    {{ directT('crm.deals.form.phone') }}
                  </label>
                  <div class="relative">
                  <input
                    v-model="newDeal.phone"
                    type="tel"
                    :readonly="!!selectedClient"
                    :placeholder="directT('crm.deals.form.phonePlaceholder')"
                      class="w-full px-4 py-3 bg-white dark:bg-gray-800 border-2 border-gray-200 dark:border-gray-600 rounded-xl focus:ring-2 focus:ring-purple-500/20 focus:border-purple-500 text-sm bg-white/80 backdrop-blur-sm transition-all duration-200 shadow-sm hover:shadow-md text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400"
                      :class="selectedClient ? 'bg-gray-100 dark:bg-gray-800 cursor-not-allowed' : ''"
                  />
                    <div class="absolute right-3 top-1/2 -translate-y-1/2">
                      <i class="material-symbols-outlined text-gray-400 text-sm">phone</i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <!-- Deal Products Section -->
            <div v-if="dealProducts.length > 0" class="bg-white dark:bg-[#1a1a1a] rounded-2xl shadow-lg border border-gray-200/50 dark:border-gray-700/50 p-6 mb-6">
              <div class="flex items-center gap-3 mb-6">
                <div class="w-10 h-10 bg-gradient-to-br from-[#5856d6] to-[#af52de] rounded-xl flex items-center justify-center">
                  <i class="material-symbols-outlined text-white text-lg">inventory</i>
                </div>
                <h3 class="text-lg font-bold text-gray-900 dark:text-white leading-none h-10 flex items-center">
                  {{ directT('crm.deals.form.productsInDeal', { count: dealProducts.length }) }}
                </h3>
              </div>
              
              <div class="space-y-4">
                <div v-for="dealProduct in dealProducts" :key="dealProduct.id" 
                     class="bg-gray-50 dark:bg-gray-800/50 rounded-xl p-4 border border-gray-200 dark:border-gray-700">
                  
                  <!-- Product Header -->
                  <div class="flex items-start justify-between mb-4">
                    <div class="flex items-start gap-3">
                      <div v-if="dealProduct.imageLink" class="w-16 h-16 rounded-lg overflow-hidden bg-gray-200 dark:bg-gray-700">
                        <img :src="dealProduct.imageLink" :alt="dealProduct.title" class="w-full h-full object-cover">
                      </div>
                      <div v-else class="w-16 h-16 rounded-lg bg-gradient-to-br from-purple-500 to-pink-500 flex items-center justify-center">
                        <i class="material-symbols-outlined text-white text-xl">inventory</i>
                      </div>
                      
                                             <div class="flex-1 min-w-0">
                         <div class="flex items-center gap-2">
                           <h4 class="font-semibold text-gray-900 dark:text-white truncate">{{ dealProduct.title }}</h4>
                           <span v-if="dealProduct.totalCards && dealProduct.totalCards > 1" 
                                 class="px-2 py-1 bg-purple-100 dark:bg-purple-900/30 text-purple-700 dark:text-purple-300 text-xs rounded-full font-medium">
                             {{ dealProduct.cardNumber }}/{{ dealProduct.totalCards }}
                           </span>
                         </div>
                         <p v-if="dealProduct.description" class="text-sm text-gray-600 dark:text-gray-400 mt-1 line-clamp-2 overflow-hidden">
                           {{ dealProduct.description }}
                         </p>
                        <div class="flex items-center gap-4 mt-2">
                          <span class="text-lg font-bold text-purple-600">{{ currencySymbol }}{{ dealProduct.price }}</span>
                          <span v-if="dealProduct.compareAtPrice && dealProduct.compareAtPrice > dealProduct.price" 
                                class="text-sm text-gray-500 line-through">{{ currencySymbol }}{{ dealProduct.compareAtPrice }}</span>
                        </div>
                      </div>
                    </div>
                    
                    <button @click="removeProductFromDeal(dealProduct.id)" 
                            class="p-2 text-red-500 hover:bg-red-50 dark:hover:bg-red-900/20 rounded-lg transition-colors">
                      <i class="material-symbols-outlined text-lg">delete</i>
                    </button>
                  </div>
                  
                  <!-- Product Configuration -->
                  <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <!-- Quantity -->
                    <div>
                      <label class="block text-xs font-semibold text-gray-800 dark:text-gray-200 mb-2">
                        {{ directT('crm.deals.form.quantity') }}
                      </label>
                      <input 
                        v-model.number="dealProduct.quantity"
                        type="number"
                        min="1"
                        class="w-full px-3 py-2 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-purple-500/20 focus:border-purple-500 text-sm"
                      />
                    </div>
                    
                    <!-- Variation Selection (if product has variations) -->
                    <div v-if="dealProduct.variations.length > 0">
                      <label class="block text-xs font-semibold text-gray-800 dark:text-gray-200 mb-2">
                        {{ getVariationGroupTitle(dealProduct.variations) }}
                      </label>
                      <select 
                        v-model="dealProduct.selectedVariation"
                        class="w-full px-3 py-2 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-purple-500/20 focus:border-purple-500 text-sm"
                      >
                        <option value="">{{ getVariationPlaceholder(dealProduct.variations) }}</option>
                        <option v-for="variation in dealProduct.variations" :key="variation.id" :value="variation">
                          {{ getVariationOptionText(variation, dealProduct.price) }}
                        </option>
                      </select>
                    </div>
                  </div>
                  

                  
                  <!-- Custom Fields for Product (if any) -->
                  <div v-if="dealProduct.customFields && dealProduct.customFields.length > 0" class="mt-4 pt-4 border-t border-gray-200 dark:border-gray-600">
                    <h5 class="text-sm font-semibold text-gray-800 dark:text-gray-200 mb-3">
                      {{ directT('crm.deals.form.productCustomFields') }}
                    </h5>
                    <div class="grid grid-cols-1 md:grid-cols-2 gap-3">
                      <template v-for="customField in dealProduct.customFields" :key="customField.id">
                        
                        <!-- Handle different content structures -->
                        <template v-if="customField.content">
                          <!-- Old structure: content is array -->
                          <template v-if="Array.isArray(customField.content)">
                            <div v-for="field in customField.content" :key="field.key || field.id" class="space-y-1">
                              <label class="block text-xs font-medium text-gray-700 dark:text-gray-300">
                                {{ field.label }}{{ field.required ? ' *' : '' }}
                              </label>
                              
                              <!-- Different input types -->
                              <input 
                                v-if="field.type !== 'select' && field.type !== 'textarea'"
                                :type="getInputType(field.type)"
                                v-model="dealProduct.customFieldValues[field.key || field.id]"
                                :placeholder="field.placeholder || ''"
                                class="w-full px-3 py-2 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-purple-500/20 focus:border-purple-500 text-sm"
                              />
                              
                              <textarea 
                                v-else-if="field.type === 'textarea'"
                                v-model="dealProduct.customFieldValues[field.key || field.id]"
                                :placeholder="field.placeholder || ''"
                                rows="2"
                                class="w-full px-3 py-2 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-purple-500/20 focus:border-purple-500 text-sm resize-none"
                              ></textarea>
                              
                              <select 
                                v-else
                                v-model="dealProduct.customFieldValues[field.key || field.id]"
                                class="w-full px-3 py-2 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-purple-500/20 focus:border-purple-500 text-sm"
                              >
                                <option value="">{{ directT('crm.deals.form.selectOption') }}</option>
                                <option v-for="option in field.options" :key="option" :value="option">{{ option }}</option>
                              </select>
                            </div>
                          </template>
                          
                          <!-- New structure: content.fields is array -->
                          <template v-else-if="customField.content.fields && Array.isArray(customField.content.fields)">
                            <div class="col-span-full mb-2">
                              <h6 class="text-sm font-medium text-gray-800 dark:text-gray-200">
                                {{ customField.content.name || directT('crm.deals.form.customFields') }}
                              </h6>
                            </div>
                            <div v-for="field in customField.content.fields" :key="field.id" class="space-y-1">
                              <label class="block text-xs font-medium text-gray-700 dark:text-gray-300">
                                {{ field.label }}{{ field.required ? ' *' : '' }}
                              </label>
                              
                              <!-- Different input types -->
                              <input 
                                v-if="field.type !== 'select' && field.type !== 'textarea'"
                                :type="getInputType(field.type)"
                                v-model="dealProduct.customFieldValues[field.id]"
                                :placeholder="field.placeholder || ''"
                                class="w-full px-3 py-2 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-purple-500/20 focus:border-purple-500 text-sm"
                              />
                              
                              <textarea 
                                v-else-if="field.type === 'textarea'"
                                v-model="dealProduct.customFieldValues[field.id]"
                                :placeholder="field.placeholder || ''"
                                rows="2"
                                class="w-full px-3 py-2 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-purple-500/20 focus:border-purple-500 text-sm resize-none"
                              ></textarea>
                              
                              <select 
                                v-else
                                v-model="dealProduct.customFieldValues[field.id]"
                                class="w-full px-3 py-2 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-purple-500/20 focus:border-purple-500 text-sm"
                              >
                                <option value="">{{ directT('crm.deals.form.selectOption') }}</option>
                                <option v-for="option in field.options" :key="option" :value="option">{{ option }}</option>
                              </select>
                            </div>
                          </template>
                        </template>
                        
                        <template v-else>
                          <div class="text-xs text-red-500">
                            No content for customField {{ customField.id }}
                          </div>
                        </template>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Mobile Actions Section -->
            <div class="lg:hidden bg-white dark:bg-[#1a1a1a] rounded-2xl shadow-lg border border-gray-200/50 dark:border-gray-700/50 p-6">
              <div class="flex items-center gap-3 mb-6">
                <div class="w-10 h-10 bg-gradient-to-br from-[#5856d6] to-[#af52de] rounded-xl flex items-center justify-center">
                  <i class="material-symbols-outlined text-white text-lg">settings</i>
                </div>
                <h3 class="text-lg font-bold text-gray-900 dark:text-white leading-none h-10 flex items-center">
                  {{ directT('crm.deals.form.actions') }}
                </h3>
              </div>
              
              <!-- Action Buttons -->
              <div class="space-y-4">
                <button 
                  type="submit"
                  :disabled="loading"
                  class="w-full px-6 py-3 bg-gradient-to-r from-[#5856d6] to-[#af52de] text-white font-medium rounded-2xl transition-all duration-200 hover:from-[#4338CA] hover:to-[#9333ea] disabled:opacity-50 disabled:cursor-not-allowed shadow-lg flex items-center justify-center gap-2"
                >
                  <span v-if="loading" class="inline-block w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
                  <i v-else class="material-symbols-outlined text-lg">save</i>
                  {{ loading ? directT('crm.deals.form.saving') : directT('crm.deals.form.create') }}
                </button>
                  
                <button 
                  type="button"
                  @click="openProductsPopup"
                  class="w-full px-6 py-3 bg-gradient-to-r from-[#34C759] to-[#30D158] text-white font-medium rounded-2xl transition-all duration-200 hover:from-[#28A745] hover:to-[#28A745] shadow-lg flex items-center justify-center gap-2"
                >
                  <i class="material-symbols-outlined text-lg">add_box</i>
                  {{ directT('ecommerce.addProducts') || 'Add Products' }}
                </button>
                  
                <router-link 
                  to="/crm/deals"
                  class="w-full px-6 py-3 bg-gradient-to-r from-[#dc2626] to-[#ef4444] text-white font-medium rounded-2xl transition-all duration-200 hover:from-[#b91c1c] hover:to-[#dc2626] border border-red-500 flex items-center justify-center gap-2"
                >
                  <i class="material-symbols-outlined text-lg">close</i>
                  {{ directT('crm.deals.form.cancel') }}
                </router-link>
              </div>
            </div>
          </div>
          
          <!-- Desktop Sidebar -->
          <div class="hidden lg:block lg:col-span-1">
            <div 
              ref="sidebarRef"
              class="bg-white dark:bg-[#1a1a1a] rounded-2xl shadow-lg border border-gray-200/50 dark:border-gray-700/50 p-6 z-10 transition-transform duration-100 ease-out"
              :style="{ position: 'sticky', top: sidebarTop + 'px' }"
            >
              <div class="flex items-center gap-3 mb-6">
                <div class="w-10 h-10 bg-gradient-to-br from-[#5856d6] to-[#af52de] rounded-xl flex items-center justify-center">
                  <i class="material-symbols-outlined text-white text-lg">settings</i>
                </div>
                <h3 class="text-lg font-bold text-gray-900 dark:text-white leading-none h-10 flex items-center">
                  {{ directT('crm.deals.form.actions') }}
                </h3>
              </div>
              
              <!-- Action Buttons -->
              <div class="space-y-4">
                <button 
                  type="submit"
                  :disabled="loading"
                  class="w-full px-6 py-3 bg-gradient-to-r from-[#5856d6] to-[#af52de] text-white font-medium rounded-2xl transition-all duration-200 hover:from-[#4338CA] hover:to-[#9333ea] disabled:opacity-50 disabled:cursor-not-allowed shadow-lg flex items-center justify-center gap-2"
                >
                  <span v-if="loading" class="inline-block w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
                  <i v-else class="material-symbols-outlined text-lg">save</i>
                  {{ loading ? directT('crm.deals.form.saving') : directT('crm.deals.form.create') }}
                </button>
                  
                <button 
                  type="button"
                  @click="openProductsPopup"
                  class="w-full px-6 py-3 bg-gradient-to-r from-[#34C759] to-[#30D158] text-white font-medium rounded-2xl transition-all duration-200 hover:from-[#28A745] hover:to-[#28A745] shadow-lg flex items-center justify-center gap-2"
                >
                  <i class="material-symbols-outlined text-lg">add_box</i>
                  {{ directT('ecommerce.addProducts') || 'Add Products' }}
                </button>
                  
                <router-link 
                  to="/crm/deals"
                  class="w-full px-6 py-3 bg-gradient-to-r from-[#dc2626] to-[#ef4444] text-white font-medium rounded-2xl transition-all duration-200 hover:from-[#b91c1c] hover:to-[#dc2626] border border-red-500 flex items-center justify-center gap-2"
                >
                  <i class="material-symbols-outlined text-lg">close</i>
                  {{ directT('crm.deals.form.cancel') }}
                </router-link>
              </div>
            </div>
          </div>
            </div>
          </form>
        </div>
      </div>
  
  <!-- Products Selection Popup -->
  <div v-if="showProductsPopup" class="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4">
    <div class="bg-white dark:bg-[#1a1a1a] rounded-2xl shadow-2xl border border-gray-200/50 dark:border-gray-700/50 w-full max-w-4xl max-h-[80vh] overflow-hidden mt-[100px] sm:mt-0 flex flex-col">
      <!-- Popup Header -->
      <div class="flex items-center justify-between p-6 border-b border-gray-200 dark:border-gray-700 flex-shrink-0">
        <div class="flex items-center gap-3">
          <div class="w-10 h-10 bg-gradient-to-br from-[#5856d6] to-[#af52de] rounded-xl flex items-center justify-center">
            <i class="material-symbols-outlined text-white text-lg">inventory</i>
          </div>
          <div>
            <h3 class="text-lg font-bold text-gray-900 dark:text-white">{{ directT('crm.deals.form.selectProducts') }}</h3>
            <p class="text-sm text-gray-600 dark:text-gray-400">{{ directT('crm.deals.form.selectProductsForDeal') }}</p>
          </div>
        </div>
        <button @click="closeProductsPopup" class="p-2 hover:bg-gray-100 dark:hover:bg-gray-800 rounded-lg transition-colors">
          <i class="material-symbols-outlined text-gray-500">close</i>
        </button>
      </div>
      
      <!-- Search Bar -->
      <div class="p-6 border-b border-gray-200 dark:border-gray-700 flex-shrink-0">
        <div class="relative">
          <input
            v-model="productSearchTerm"
            type="text"
            :placeholder="directT('crm.deals.form.searchProductsPlaceholder')"
            class="w-full px-4 py-3 pl-12 bg-gray-50 dark:bg-gray-800 border border-gray-200 dark:border-gray-600 rounded-xl focus:ring-2 focus:ring-purple-500/20 focus:border-purple-500 text-sm"
          />
          <div class="absolute left-4 top-1/2 -translate-y-1/2">
            <i class="material-symbols-outlined text-gray-400 text-lg">search</i>
          </div>
        </div>
      </div>
      
      <!-- Products List -->
      <div class="flex-1 overflow-y-auto min-h-0">
        <!-- Loading State -->
        <div v-if="loadingProducts" class="flex items-center justify-center py-12">
          <div class="text-center">
            <div class="inline-block w-8 h-8 border-2 border-purple-500 border-t-transparent rounded-full animate-spin mb-4"></div>
            <p class="text-gray-600 dark:text-gray-400">{{ directT('crm.deals.form.loadingProducts') }}</p>
          </div>
        </div>
        
        <!-- No Products -->
        <div v-else-if="filteredProducts.length === 0" class="flex items-center justify-center py-12">
          <div class="text-center">
            <i class="material-symbols-outlined text-gray-400 text-4xl mb-4">inventory</i>
            <p class="text-gray-600 dark:text-gray-400">{{ directT('crm.deals.form.noProductsFound') }}</p>
          </div>
        </div>
        
        <!-- Products Grid -->
        <div v-else class="p-6 grid grid-cols-1 md:grid-cols-2 gap-4 pb-4">
          <div 
            v-for="product in filteredProducts" 
            :key="product.id"
            @click="toggleProductSelection(product)"
            class="border border-gray-200 dark:border-gray-700 rounded-xl p-4 cursor-pointer transition-all duration-200 hover:shadow-md"
            :class="{
              'ring-2 ring-purple-500 bg-purple-50 dark:bg-purple-900/20': selectedProducts.some(p => p.id === product.id),
              'hover:border-purple-300 dark:hover:border-purple-600': !selectedProducts.some(p => p.id === product.id)
            }"
          >
            <div class="flex items-start gap-3">
              <!-- Product Image -->
              <div class="w-16 h-16 rounded-lg overflow-hidden bg-gray-200 dark:bg-gray-700 flex-shrink-0">
                <img v-if="product.image_link" :src="product.image_link" :alt="product.title" class="w-full h-full object-cover">
                <div v-else class="w-full h-full bg-gradient-to-br from-purple-500 to-pink-500 flex items-center justify-center">
                  <i class="material-symbols-outlined text-white text-lg">inventory</i>
                </div>
              </div>
              
              <!-- Product Info -->
              <div class="flex-1 min-w-0">
                <div class="flex items-start justify-between">
                                     <div class="flex-1 min-w-0">
                     <h4 class="font-semibold text-gray-900 dark:text-white truncate">{{ product.title }}</h4>
                     <p v-if="product.description" class="text-sm text-gray-600 dark:text-gray-400 mt-1 line-clamp-2 overflow-hidden">
                       {{ product.description }}
                     </p>
                    
                    <!-- Price -->
                    <div class="flex items-center gap-2 mt-2">
                      <span class="text-lg font-bold text-purple-600">{{ currencySymbol }}{{ product.price || 0 }}</span>
                      <span v-if="product.compare_at_price && product.compare_at_price > (product.price || 0)" 
                            class="text-sm text-gray-500 line-through">{{ currencySymbol }}{{ product.compare_at_price }}</span>
                    </div>
                    
                                         <!-- Product Details -->
                     <div class="flex items-center gap-4 mt-2 text-xs text-gray-500 dark:text-gray-400">
                       <span v-if="product.category" class="flex items-center gap-1">
                         <i class="material-symbols-outlined text-xs">category</i>
                         {{ product.category }}
                       </span>
                       <span v-if="product.has_variants" class="flex items-center gap-1">
                         <i class="material-symbols-outlined text-xs">tune</i>
                         {{ directT('crm.deals.form.hasVariations') }}
                       </span>
                       <span v-if="product.customFields && product.customFields.length > 0" class="flex items-center gap-1">
                         <i class="material-symbols-outlined text-xs">settings</i>
                         {{ directT('crm.deals.form.customFields') }}
                       </span>
                     </div>
                     
                     <!-- Quantity Input (only if product is selected) -->
                     <div v-if="selectedProducts.some(p => p.id === product.id)" class="mt-3 pt-3 border-t border-gray-200 dark:border-gray-600">
                       <label class="block text-xs font-semibold text-gray-800 dark:text-gray-200 mb-2">
                         {{ directT('crm.deals.form.quantityCardsToCreate') }}
                       </label>
                       <div class="flex items-center gap-2">
                         <button 
                           @click.stop="updateProductQuantity(product.id, Math.max(1, (productQuantities[product.id] || 1) - 1))"
                           class="w-8 h-8 bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600 rounded-lg flex items-center justify-center transition-colors"
                         >
                           <i class="material-symbols-outlined text-sm">remove</i>
                         </button>
                         <input 
                           :value="productQuantities[product.id] || 1"
                           @input="updateProductQuantity(product.id, parseInt(($event.target as HTMLInputElement).value) || 1)"
                           @click.stop
                           type="number"
                           min="1"
                           class="w-16 px-2 py-1 text-center bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-purple-500/20 focus:border-purple-500 text-sm"
                         />
                         <button 
                           @click.stop="updateProductQuantity(product.id, (productQuantities[product.id] || 1) + 1)"
                           class="w-8 h-8 bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600 rounded-lg flex items-center justify-center transition-colors"
                         >
                           <i class="material-symbols-outlined text-sm">add</i>
                         </button>
                       </div>
                       <p class="text-xs text-gray-500 dark:text-gray-400 mt-1">
                         {{ directT('crm.deals.form.separateCardsWillBeCreated', { count: productQuantities[product.id] || 1 }) }}
                       </p>
                     </div>
                   </div>
                  
                  <!-- Selection Checkbox -->
                  <div class="flex-shrink-0 ml-3">
                    <div class="w-6 h-6 rounded-full border-2 flex items-center justify-center transition-all duration-200"
                         :class="{
                           'border-purple-500 bg-purple-500': selectedProducts.some(p => p.id === product.id),
                           'border-gray-300 dark:border-gray-600': !selectedProducts.some(p => p.id === product.id)
                         }">
                      <i v-if="selectedProducts.some(p => p.id === product.id)" 
                         class="material-symbols-outlined text-white text-sm">check</i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <!-- Popup Footer - Always Visible -->
      <div class="flex-shrink-0 border-t border-gray-200 dark:border-gray-700 bg-white dark:bg-[#1a1a1a]">
        <div class="flex items-center justify-between p-4 sm:p-6">
          <div class="text-sm text-gray-600 dark:text-gray-400">
            {{ directT('crm.deals.form.selectedProducts', { count: selectedProducts.length }) }}
          </div>
          <div class="flex items-center gap-3">
            <button 
              @click="closeProductsPopup"
              class="px-4 py-2 text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800 rounded-lg transition-colors"
            >
              {{ directT('crm.deals.form.cancel') }}
            </button>
            <button 
              @click="addSelectedProducts"
              :disabled="selectedProducts.length === 0"
              class="px-6 py-2 bg-gradient-to-r from-[#5856d6] to-[#af52de] text-white font-medium rounded-lg transition-all duration-200 hover:from-[#4338CA] hover:to-[#9333ea] disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2"
            >
              <i class="material-symbols-outlined text-sm">add</i>
              {{ directT('crm.deals.form.addProducts', { count: selectedProducts.length }) }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, reactive, onMounted, onBeforeUnmount, computed } from "vue";
import { useRouter, useRoute } from 'vue-router';
import { supabase } from "@/lib/supabaseClient";
import { getCurrentOrgId } from "@/utils/getCurrentOrgId";
import { createToast } from "@/utils/toast";
import emitter from "@/utils/emitter";
import { useI18n } from 'vue-i18n';
import enTranslations from '@/i18n/locales/en.json';
import heTranslations from '@/i18n/locales/he.json';
import arTranslations from '@/i18n/locales/ar.json';

type TranslationObject = Record<string, any>;

interface NewDeal {
  title: string;
  name: string;
  phone: string;
  amount: number | null;
  description: string;
  status: string;
  organization_id: string | null;
  created_by: string | null;
  connecttoclients: string | null;
}

interface Client {
  id: string;
  first_name: string | null;
  last_name: string | null;
  phone: string | null;
  email: string | null;
}

export default defineComponent({
  name: "CreateDealPage",
  setup() {
    const router = useRouter();
    const route = useRoute();
    const loading = ref(false);
    const error = ref<string | null>(null);
    const { locale } = useI18n();
    const currencySymbol = ref('₪');
    
    // RTL support
    const isRtl = computed(() => locale.value === 'he' || locale.value === 'ar');
    
    // Client search related
    const clientSearchTerm = ref('');
    const showClientDropdown = ref(false);
    const searchingClients = ref(false);
    const filteredClients = ref<Client[]>([]);
    const selectedClient = ref<Client | null>(null);
    const searchDebounce = ref<number | null>(null);
    
    // Organization ID
    const organizationId = ref<string | null>(null);
    
    // Users related
    const users = ref<any[]>([]);
    const loadingUsers = ref(false);

    // Custom fields
    const customFields = ref<any[]>([]);
    const customFieldValues = ref<Record<string, any>>({});
    const loadingCustomFields = ref(false);
    const systemAreas = ref<any[]>([]);
    
    // Products selection
    const showProductsPopup = ref(false);
    const products = ref<any[]>([]);
    const loadingProducts = ref(false);
    const selectedProducts = ref<any[]>([]);
    const dealProducts = ref<any[]>([]);
    const productSearchTerm = ref('');
    const productQuantities = ref<Record<string, number>>({});
    
    // Pre-load custom fields as early as possible
    const preloadCustomFields = async () => {
      try {
        const orgId = await getCurrentOrgId();
        if (orgId) {
          organizationId.value = orgId;
          // Start loading custom fields immediately in background
          fetchCustomFields(orgId);
        }
      } catch (error) {
        console.warn('Failed to preload custom fields:', error);
      }
    };
    
    // Sidebar scroll tracking
    const sidebarRef = ref<HTMLElement | null>(null);
    const sidebarTop = ref(16); // 16px = top-4
    
    // Translation files
    const translationFiles = {
      en: enTranslations,
      he: heTranslations,
      ar: arTranslations
    };

    // Direct translation function that bypasses vue-i18n
    const directT = (key: string, params?: Record<string, any>): string => {
      const parts = key.split('.');
      let result: TranslationObject = translationFiles[locale.value as keyof typeof translationFiles];
      
      for (const part of parts) {
        if (!result || !(part in result)) {
          console.warn(`Missing translation key: ${key} in ${locale.value} locale`);
          // Fallback to English if translation not found
          let enResult: TranslationObject = translationFiles.en;
          for (const fallbackPart of parts) {
            if (!enResult || !(fallbackPart in enResult)) return key;
            enResult = enResult[fallbackPart as keyof typeof enResult] as TranslationObject;
          }
          result = enResult;
          break;
        }
        result = result[part as keyof typeof result] as TranslationObject;
      }
      
      let translation = typeof result === 'string' ? result : key;
      
      // Replace parameters if provided
      if (params) {
        Object.keys(params).forEach(paramKey => {
          translation = translation.replace(new RegExp(`\\{${paramKey}\\}`, 'g'), String(params[paramKey]));
        });
      }
      
      return translation;
    };
    
    const newDeal = reactive<NewDeal>({
      title: '',
      name: '',
      phone: '',
      amount: null,
      description: '',
      status: 'new',
      organization_id: null,
      created_by: null,
      connecttoclients: null,
    });

    const getCurrencySymbol = (code: string): string => {
      const currencySymbols: Record<string, string> = {
        'USD': '$',
        'EUR': '€',
        'GBP': '£',
        'ILS': '₪',
        'JPY': '¥',
        'CNY': '¥',
        'INR': '₹',
        'AUD': 'A$',
        'CAD': 'C$',
        'CHF': 'Fr',
        'SEK': 'kr',
        'NOK': 'kr',
        'DKK': 'kr',
        'RUB': '₽',
        'BRL': 'R$',
        'MXN': '$',
        'ARS': '$',
        'CLP': '$',
        'COP': '$',
        'PEN': 'S/',
        'UYU': '$',
      };
      
      return currencySymbols[code] || code;
    };

    const loadOrganizationCurrency = async () => {
      try {
        const organizationId = await getCurrentOrgId();
        if (!organizationId) return;
        
        const { data: orgData, error: orgError } = await supabase
          .from('organizations')
          .select('currency')
          .eq('id', organizationId)
          .single();
          
        if (!orgError && orgData && orgData.currency) {
          const currencyValue = (orgData.currency as string).trim();
          
          // Check if it's a standard 3-letter currency code
          const isStandardCode = /^[A-Z]{3}$/i.test(currencyValue);
          
          if (isStandardCode) {
            currencySymbol.value = getCurrencySymbol(currencyValue.toUpperCase());
          } else {
            // It's probably already a symbol
            currencySymbol.value = currencyValue;
          }
        }
      } catch (err) {
        console.error('Error loading organization currency:', err);
      }
    };

    // Client search functions
    const searchClients = () => {
      // Clear previous timeout
      if (searchDebounce.value) {
        clearTimeout(searchDebounce.value);
      }

      // Debounce search
      searchDebounce.value = window.setTimeout(async () => {
        if (!clientSearchTerm.value.trim()) {
          filteredClients.value = [];
          return;
        }

        try {
          searchingClients.value = true;
          const organizationId = await getCurrentOrgId();
          if (!organizationId) return;

          const searchValue = clientSearchTerm.value.toLowerCase();
          
          // Search in both first_name, last_name and phone
          const { data, error } = await supabase
            .from('clients')
            .select('id, first_name, last_name, phone, email')
            .eq('organization_id', organizationId)
            .or(`first_name.ilike.%${searchValue}%,last_name.ilike.%${searchValue}%,phone.ilike.%${searchValue}%`)
            .limit(10);

          if (error) throw error;

          filteredClients.value = (data as Client[]) || [];
        } catch (err) {
          console.error('Error searching clients:', err);
          filteredClients.value = [];
        } finally {
          searchingClients.value = false;
        }
      }, 300);
    };

    // Fetch organization users
    const fetchUsers = async () => {
      try {
        if (!organizationId.value) {
          console.warn('Cannot fetch users: Missing organization ID');
          return;
        }
        
        loadingUsers.value = true;
        
        const { data, error } = await supabase
          .from('user_profiles')
          .select('user_id, display_name, email')
          .eq('org_id', organizationId.value);
        
        if (error) throw error;
        
        users.value = data || [];
        console.log('Users loaded:', users.value);
      } catch (error) {
        console.error('Error fetching users:', error);
        createToast('Failed to load users', 'error');
      } finally {
        loadingUsers.value = false;
      }
    };

    const getClientFullName = (client: Client): string => {
      const firstName = client.first_name || '';
      const lastName = client.last_name || '';
      return `${firstName} ${lastName}`.trim() || 'לקוח ללא שם';
    };

    const selectClient = (client: Client) => {
      selectedClient.value = client;
      newDeal.connecttoclients = client.id;
      newDeal.name = getClientFullName(client);
      newDeal.phone = client.phone || '';
      showClientDropdown.value = false;
      clientSearchTerm.value = '';
      filteredClients.value = [];
    };

    const clearSelectedClient = () => {
      selectedClient.value = null;
      newDeal.connecttoclients = null;
      newDeal.name = '';
      newDeal.phone = '';
    };

    const handleSearchBlur = () => {
      window.setTimeout(() => {
        showClientDropdown.value = false;
      }, 200);
    };

    // Load client from query parameters if provided
    const loadClientFromQuery = async () => {
      try {
        const clientId = route.query.clientId as string;
        const autoSelect = route.query.autoSelect as string;
        
        if (!clientId || autoSelect !== 'true') {
          return;
        }
        
        console.log('📋 Loading client from query parameters:', clientId);
        
        const organizationId = await getCurrentOrgId();
        if (!organizationId) return;
        
        // Fetch the client from database
        const { data: clientData, error: clientError } = await supabase
          .from('clients')
          .select('id, first_name, last_name, phone, email')
          .eq('id', clientId)
          .eq('organization_id', organizationId)
          .single();
        
        if (clientError) {
          console.error('Error loading client from query:', clientError);
          createToast('שגיאה בטעינת נתוני הלקוח', 'error');
          return;
        }
        
        if (clientData) {
          // Auto-select the client
          selectClient(clientData as Client);
          createToast(`לקוח נבחר: ${getClientFullName(clientData as Client)}`, 'success');
          console.log('✅ Client auto-selected from query parameters');
        }
        
      } catch (err) {
        console.error('Error in loadClientFromQuery:', err);
      }
    };

    const saveDeal = async () => {
      try {
        loading.value = true;
        error.value = null;
        
        // Get current user and organization
        const { data: userData, error: userError } = await supabase.auth.getUser();
        if (userError) throw userError;
        
        const orgId = await getCurrentOrgId();
        if (!orgId) {
          throw new Error(directT('crm.deals.form.error'));
        }
        
        // Prepare deal data according to the new table structure
        const dealData = {
          organization_id: orgId,
          title: newDeal.title,
          description: newDeal.description || null,
          status: newDeal.status || 'new',
          amount: newDeal.amount,
          name: newDeal.name || null,
          phone: newDeal.phone || null,
          customer_id: selectedClient.value?.id || null,
          connecttoclients: selectedClient.value?.id || null,
          created_by: userData.user?.id || null,
          closedby: null,
          products: dealProducts.value.length > 0 ? dealProducts.value.map(p => p.productId) : null
        };
        
        // 1. Insert the deal into the database
        const { data: insertedDeal, error: insertError } = await supabase
          .from('deals')
          .insert(dealData)
          .select()
          .single();
          
        if (insertError) throw insertError;
        
        const dealId = insertedDeal.id;
        
        // 2. Save products in deal
        if (dealProducts.value.length > 0) {
          const productsInDeal = [];
          
          for (const dealProduct of dealProducts.value) {
            productsInDeal.push({
              deal_id: dealId,
              product_id: dealProduct.productId
            });
          }
          
          const { data: insertedProductsInDeal, error: productsError } = await supabase
            .from('products_in_deal')
            .insert(productsInDeal)
            .select();
            
          if (productsError) throw productsError;
          
          // 3. Save product variations and custom fields
          for (let i = 0; i < dealProducts.value.length; i++) {
            const dealProduct = dealProducts.value[i];
            const productInDeal = insertedProductsInDeal?.[i];
            
            // Save variation if selected
            if (dealProduct.selectedVariation) {
              await supabase
                .from('product_variations_in_deal')
                .insert({
                  deal_id: dealId,
                  product_id: dealProduct.productId,
                  product_in_deal_id: productInDeal?.id,
                  variation_id: dealProduct.selectedVariation.id
                });
            }
            
                         // 4. Save custom product fields
             if (dealProduct.customFieldValues && Object.keys(dealProduct.customFieldValues).length > 0) {
               const customFieldInserts = [];
               
               for (const [fieldKey, content] of Object.entries(dealProduct.customFieldValues)) {
                 if (content !== undefined && content !== null && content !== '') {
                   // Find the custom field ID for product field
                   let customFieldId = null;
                   
                   // Look for the field in the product's custom fields
                   if (dealProduct.customFields && Array.isArray(dealProduct.customFields)) {
                     for (const customField of dealProduct.customFields) {
                       if (customField.content) {
                         // Handle different content structures
                         const fields = Array.isArray(customField.content) ? customField.content : 
                                       (customField.content.fields ? customField.content.fields : []);
                         
                         const field = fields.find((f: any) => f.key === fieldKey || f.id === fieldKey);
                         if (field) {
                           customFieldId = customField.id;
                           break;
                         }
                       }
                     }
                   }
                   
                   customFieldInserts.push({
                     deal_id: dealId,
                     product_id: dealProduct.productId,
                     product_in_deal_id: productInDeal?.id,
                     customer_id: selectedClient.value?.id || null,
                     fieldkey: fieldKey,
                     content: String(content),
                     custom_field_id: customFieldId
                   });
                 }
               }
               
               if (customFieldInserts.length > 0) {
                 await supabase
                   .from('customproductsfieldcontent')
                   .insert(customFieldInserts);
               }
             }
          }
        }
        
                 // 5. Save deal custom field values
         if (Object.keys(customFieldValues.value).length > 0) {
           const dealCustomFieldInserts = [];
           
           for (const [fieldKey, content] of Object.entries(customFieldValues.value)) {
             if (content !== undefined && content !== null && content !== '') {
               // Find the custom field ID based on fieldKey
               let customFieldId = null;
               
               // Check in regular custom fields
               const regularField = customFields.value.find(f => f.key === fieldKey);
               if (regularField && (regularField as any).customFieldsId) {
                 customFieldId = (regularField as any).customFieldsId;
               }
               
               // Check in system areas if not found
               if (!customFieldId) {
                 for (const area of systemAreas.value) {
                   const areaField = area.fields?.find((f: any) => f.key === fieldKey);
                   if (areaField) {
                     // You may need to map area to customFieldsId here
                     break;
                   }
                 }
               }
               
               dealCustomFieldInserts.push({
                 deal_id: dealId,
                 customer_id: selectedClient.value?.id || null,
                 fieldkey: fieldKey,
                 content: String(content),
                 customdealfieldid: customFieldId
               });
             }
           }
           
           if (dealCustomFieldInserts.length > 0) {
             await supabase
               .from('customdealfieldcontent')
               .insert(dealCustomFieldInserts);
           }
         }
        
        // Show success message
        createToast(directT('crm.deals.form.successMessage'), 'success');
        
        // Emit event to refresh deals list
        emitter.emit('refresh-deals');
        
        // Navigate back to deals page
        router.push('/crm/deals');
        
      } catch (err) {
        console.error('Error saving deal:', err);
        error.value = err instanceof Error ? err.message : directT('crm.deals.form.error');
      } finally {
        loading.value = false;
      }
    };

    // Get appropriate input type based on custom field type
    const getInputType = (fieldType: string) => {
      switch (fieldType) {
        case 'number': return 'number';
        case 'email': return 'email';
        case 'phone': return 'tel';
        case 'date': return 'date';
        case 'checkbox': return 'checkbox';
        case 'select': return 'select';
        default: return 'text';
      }
    };

    // Fetch custom fields
    const fetchCustomFields = async (orgId?: string) => {
      const startTime = performance.now();
      
      try {
        const currentOrgId = orgId || organizationId.value;
        if (!currentOrgId) {
          console.warn('Cannot fetch custom fields: Missing organization ID');
          return;
        }
        
        loadingCustomFields.value = true;
        
        // Optimized query with specific selection and ordering
        // Optimized query leveraging database indexes
        const { data, error } = await supabase
          .from('customdealsfield')
          .select('id, content')
          .eq('organizationid', currentOrgId)
          .not('content', 'is', null)
          .order('id', { ascending: true })
          .limit(100); // Add reasonable limit for safety
        
        console.log('Supabase response for customdealsfield:', { data, error });
        
        if (error) throw error;
        
        if (!data || data.length === 0) {
          // No custom fields defined
          customFields.value = [];
          systemAreas.value = [];
          return;
        }
        
        // Reset the custom fields array and system areas
        customFields.value = [];
        systemAreas.value = [];
        
        // Use Map for faster area lookups
        const areaMap = new Map();
        const fieldValues: Record<string, any> = {};
        
        // Process all records in a more efficient way with batching
        const processRecord = (record: any) => {
          if (!record?.content || !Array.isArray(record.content)) return;
          
          const content = record.content as any[];
          console.log("Processing record:", record.id, "content:", content);
          
          if (content.length === 0) return;
          
          // Check if this is a system area (has areaId)
          if (content[0].areaId) {
            const areaId = content[0].areaId;
            const areaTitle = content[0].area;
            
            console.log("Found system area:", areaTitle, "with", content.length, "fields");
            
            // Get or create area
            let existingArea = areaMap.get(areaId);
            if (!existingArea) {
              existingArea = {
                id: areaId,
                title: areaTitle,
                fields: [],
              };
              areaMap.set(areaId, existingArea);
            }
            
            // Process fields in batch
            const fields = content.map(fieldData => {
              const field = {
                id: fieldData.key.split("_")[1] || fieldData.key,
                label: fieldData.label.replace(`${areaTitle} - `, ""),
                type: fieldData.type,
                required: fieldData.required || false,
                key: fieldData.key,
                placeholder: fieldData.placeholder || '',
                options: fieldData.options || []
              };
              
              // Initialize field value
              fieldValues[fieldData.key] = '';
              return field;
            });
            
            existingArea.fields.push(...fields);
          } else {
            // Process regular custom fields in batch
            console.log("Found regular custom field:", content[0]);
            const fields = content
              .filter(field => field) // Remove null/undefined
              .map(field => {
                (field as any).customFieldsId = record.id;
                fieldValues[field.key] = '';
                return field;
              });
            
            customFields.value.push(...fields);
          }
        };
        
        // Process all records
        data.forEach(processRecord);
        
        // Convert Map to array
        systemAreas.value = Array.from(areaMap.values());
        
        // Set all field values at once
        customFieldValues.value = { ...customFieldValues.value, ...fieldValues };
        
        const endTime = performance.now();
        const loadTime = endTime - startTime;
        
        console.log("Custom fields loaded:", customFields.value);
        console.log("System areas loaded:", systemAreas.value);
        console.log(`⚡ Custom fields loaded in ${loadTime.toFixed(2)}ms`);
      } catch (error) {
        console.error('Error fetching custom fields:', error);
        createToast('Failed to load custom fields', 'error');
      } finally {
        loadingCustomFields.value = false;
      }
    };

    // Fetch products from database
    const fetchProducts = async () => {
      try {
        if (!organizationId.value) {
          console.warn('Cannot fetch products: Missing organization ID');
          return;
        }
        
        loadingProducts.value = true;
        
        // Get products with their variations and custom fields
        const { data: productsData, error: productsError } = await supabase
          .from('products')
          .select(`
            id,
            title,
            description,
            price,
            compare_at_price,
            has_variants,
            image_link,
            category,
            product_type,
            tags
          `)
          .eq('org_id', organizationId.value)
          .order('title', { ascending: true });
        
        if (productsError) throw productsError;
        
        if (!productsData || productsData.length === 0) {
          products.value = [];
          return;
        }
        
        // For each product, check if it has variations and custom fields
        const enrichedProducts = await Promise.all(
          productsData.map(async (product) => {
            const enrichedProduct = { ...product, variations: [] as any[], customFields: [] as any[] };
            
            // Get variations if product has them
            if (product.has_variants) {
              const { data: variations, error: variationsError } = await supabase
                .from('productvariations')
                .select('*')
                .eq('product_id', product.id)
                .order('title', { ascending: true });
              
              if (!variationsError && variations) {
                enrichedProduct.variations = variations;
              }
            }
            
            // Get custom fields for this product
            const { data: customFields, error: customFieldsError } = await supabase
              .from('customproductsfield')
              .select('*')
              .eq('organizationid', organizationId.value)
              .eq('product_id', product.id);
            
            if (!customFieldsError && customFields && customFields.length > 0) {
              enrichedProduct.customFields = customFields;
              console.log(`Product ${product.title} has ${customFields.length} custom fields:`, customFields);
            } else {
              console.log(`Product ${product.title} has no custom fields`);
            }
            
            return enrichedProduct;
          })
        );
        
        products.value = enrichedProducts;
        console.log('Products loaded:', products.value);
      } catch (error) {
        console.error('Error fetching products:', error);
        createToast('Failed to load products', 'error');
      } finally {
        loadingProducts.value = false;
      }
    };
    
    // Open products selection popup
    const openProductsPopup = async () => {
      showProductsPopup.value = true;
      selectedProducts.value = [];
      if (products.value.length === 0) {
        await fetchProducts();
      }
    };
    
    // Close products popup
    const closeProductsPopup = () => {
      showProductsPopup.value = false;
      selectedProducts.value = [];
      productSearchTerm.value = '';
      productQuantities.value = {};
    };
    
    // Toggle product selection
    const toggleProductSelection = (product: any) => {
      const index = selectedProducts.value.findIndex(p => p.id === product.id);
      if (index > -1) {
        selectedProducts.value.splice(index, 1);
        delete productQuantities.value[product.id];
      } else {
        selectedProducts.value.push(product);
        productQuantities.value[product.id] = 1; // Default quantity
      }
    };
    
    // Update product quantity
    const updateProductQuantity = (productId: string, quantity: number) => {
      if (quantity > 0) {
        productQuantities.value[productId] = quantity;
      }
    };
    
    // Add selected products to deal
    const addSelectedProducts = () => {
      let totalCardsAdded = 0;
      
      selectedProducts.value.forEach(product => {
        const quantity = productQuantities.value[product.id] || 1;
        
        // Create multiple cards based on quantity
        for (let i = 0; i < quantity; i++) {
          const dealProduct = {
            id: `deal-product-${Date.now()}-${Math.random()}-${i}`,
            productId: product.id,
            title: product.title,
            description: product.description,
            price: product.price || 0,
            compareAtPrice: product.compare_at_price,
            quantity: 1, // Each card represents 1 item
            selectedVariation: null,
            customFieldValues: {} as Record<string, any>,
            variations: product.variations || [],
            customFields: product.customFields || [],
            imageLink: product.image_link,
            category: product.category,
            productType: product.product_type,
            tags: product.tags || [],
            cardNumber: i + 1, // Card number for display
            totalCards: quantity // Total cards for this product
          };
          
                  // Initialize custom field values
        if (product.customFields && product.customFields.length > 0) {
          product.customFields.forEach((customField: any) => {
            // Handle different content structures
            let fields = [];
            if (customField.content) {
              if (Array.isArray(customField.content)) {
                // Old structure: content is array
                fields = customField.content;
              } else if (customField.content.fields && Array.isArray(customField.content.fields)) {
                // New structure: content.fields is array
                fields = customField.content.fields;
              }
            }
            
            fields.forEach((field: any) => {
              const fieldKey = field.key || field.id || `field_${field.label}`;
              dealProduct.customFieldValues[fieldKey] = '';
            });
          });
        }
          
          dealProducts.value.push(dealProduct);
          totalCardsAdded++;
        }
      });
      
      closeProductsPopup();
      createToast(`Added ${totalCardsAdded} product cards to deal`, 'success');
    };
    
    // Remove product from deal
    const removeProductFromDeal = (dealProductId: string) => {
      const index = dealProducts.value.findIndex(p => p.id === dealProductId);
      if (index > -1) {
        dealProducts.value.splice(index, 1);
        createToast('Product removed from deal', 'success');
      }
    };
    
    // Filter products based on search term
    const filteredProducts = computed(() => {
      if (!productSearchTerm.value.trim()) {
        return products.value;
      }
      
      const searchTerm = productSearchTerm.value.toLowerCase();
      return products.value.filter(product => 
        product.title.toLowerCase().includes(searchTerm) ||
        (product.description && product.description.toLowerCase().includes(searchTerm)) ||
        (product.category && product.category.toLowerCase().includes(searchTerm)) ||
        (product.tags && product.tags.some((tag: string) => tag.toLowerCase().includes(searchTerm)))
      );
    });
    
    // Get variation group title from variations
    const getVariationGroupTitle = (variations: any[]) => {
      if (!variations || variations.length === 0) return 'וריאציה';
      
      // Group variations by title to find common patterns
      const titleGroups = variations.reduce((groups: Record<string, number>, variation) => {
        const title = variation.title || '';
        // Extract the part before the first dash or colon (common separators)
        const groupName = title.split(/[-:]/)[0].trim();
        groups[groupName] = (groups[groupName] || 0) + 1;
        return groups;
      }, {});
      
      // Find the most common group name
      const mostCommonGroup = Object.keys(titleGroups).reduce((a, b) => 
        titleGroups[a] > titleGroups[b] ? a : b
      );
      
      return mostCommonGroup || 'וריאציה';
    };
    
    // Get variation placeholder text
    const getVariationPlaceholder = (variations: any[]) => {
      const groupTitle = getVariationGroupTitle(variations);
      return `בחר ${groupTitle}`;
    };
    
    // Get variation option display text
    const getVariationOptionText = (variation: any, basePrice: number) => {
      const title = variation.title || 'ללא שם';
      const price = variation.price || basePrice;
      
      // If variation has content, show it as additional info
      if (variation.content && variation.content.trim()) {
        return `${title} - ${currencySymbol.value}${price} (${variation.content})`;
      }
      
      return `${title} - ${currencySymbol.value}${price}`;
    };



    // Handle scroll for sidebar
    const handleScroll = () => {
      if (!sidebarRef.value) return;
      
      const scrollY = window.scrollY;
      const newTop = Math.max(16, 16 + scrollY);
      sidebarTop.value = newTop;
      
      sidebarRef.value.style.transform = `translateY(${scrollY}px)`;
    };

          // Start preloading custom fields immediately when component is created
      preloadCustomFields();

    onMounted(async () => {
        // If organization ID is not loaded yet, load it
        if (!organizationId.value) {
          organizationId.value = await getCurrentOrgId();
        }
        
        // Load other data in parallel
        await Promise.all([
          loadOrganizationCurrency(),
          loadClientFromQuery(),
          fetchUsers()
        ]);
        
        // Add scroll listener
        window.addEventListener('scroll', handleScroll);
    });

    onBeforeUnmount(() => {
      // Clear search debounce
      if (searchDebounce.value) {
        clearTimeout(searchDebounce.value);
      }
      
      // Remove scroll listener
      window.removeEventListener('scroll', handleScroll);
    });

    return {
      newDeal,
      loading,
      error,
      saveDeal,
      directT,
      currencySymbol,
      isRtl,
      // Client search
      clientSearchTerm,
      showClientDropdown,
      searchingClients,
      filteredClients,
      selectedClient,
      searchClients,
      getClientFullName,
      selectClient,
      clearSelectedClient,
      handleSearchBlur,
      // Users
      users,
      loadingUsers,
      fetchUsers,
      // Custom fields
      customFields,
      customFieldValues,
      loadingCustomFields,
      systemAreas,
      getInputType,
      // Products
      showProductsPopup,
      products,
      loadingProducts,
      selectedProducts,
      dealProducts,
      productSearchTerm,
      productQuantities,
      filteredProducts,
      openProductsPopup,
      closeProductsPopup,
      toggleProductSelection,
      updateProductQuantity,
      addSelectedProducts,
      removeProductFromDeal,
      getVariationGroupTitle,
      getVariationPlaceholder,
      getVariationOptionText,
      // Sidebar
      sidebarRef,
      sidebarTop
    };
  },
});
</script> 

<style scoped>
.line-clamp-2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.line-clamp-3 {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style> 